import { Box, Grid, MenuItem, Tooltip, Typography } from '@mui/material'
import _ from 'lodash'
import { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

/** TRANSLATION */
import { useTranslation } from 'react-i18next'

/** API*/
import TreatmentApi, { FindDoctorFeeProps } from 'api/dentists/treatment.api'
import OperativeApi from 'api/setting/treatments/operative.api'

/** CONSTANTS */
import { colors } from 'constants/theme'

/** UTILS || SLICE */
import * as modalSlice from 'app/slice/modal.slice'
import { TreatmentStateInterface, checkApprovalRight, loadPromotionTreatments, promotionsTreatments, setApprovalRight, setTreatmentByKey, treatment } from 'app/slice/treatment.slice'
import { getBranch, getClinicInfo, getPackage, numberFormat } from 'utils/app.utils'

/** COMPONENT */
import InputTextField from 'component/Input/InputTextField'
import InputTextarea from 'component/Input/InputTextarea'
import Loading from 'component/Loading'
import ModalCustom from 'component/ModalCustom/ModalCustom'
import BasicSelect from 'component/Select/BasicSelect'

/** STYLE */
import { styled } from '@mui/material/styles'
import ApprovalApi, { ApprovalCancelReceipt, ApprovalStatus } from 'api/approval/approval.api'
import TreatmentsAPI from 'api/dentists/treatment.api'
import { swalCustom } from 'component/Alert/Swal'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import 'component/Treatments/style/modal.css'
import { ApprovalSelectorCustom } from 'features/approvel-list/approvel-list'
import { useLocation } from 'react-router-dom'

import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined'
import InfoIcon from '@mui/icons-material/Info'
import { selectMe } from 'app/slice/user.slice'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import { ModalSelectPromotionExtra, onPromotionSave } from 'features/manage-crm/promotion/promotion-component'
import MainButton from 'new-components/buttons/main-button'
import { dateToView } from 'utils/date.utils'
// import IconClose from 'assets/icon/iconClose'
import IconClose from '@mui/icons-material/CloseRounded'
import VoucherApi, { VoucherFindByCodeProps } from 'api/voucher/voucher.api'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import { Config } from 'config'
import moment from 'moment'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PaymentInstallmentBox, { PERCENT_OP, PaymentInstallmentListProps, PaymentInstallmentListStatus } from './PaymentInstallment/PaymentInstallment'

export enum CURRENCY_UNIT {
  BAHT = 'BAHT',
  PERCENT = 'PERCENT'
}

const Title = styled(Typography)(({ theme }) => ({
  color: colors.themeMainColor,
  [theme.breakpoints.up(375)]: {
    fontSize: 18
  }
}))

const CustomLoading = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: colors.backdrop,
  zIndex: 2016
}))

export interface IPopupManageTreatmentCourse {
  itemId?: number // index treatments || products
  userId?: number
  operative: any
  onSubmit?: () => void
  onReset?: () => void
  noModal?: boolean
  branchId?: number
  patient?: any
  type?: 'Treatment' | 'Payment' | 'HistoryTreatment' | 'RetrospectiveOrder' | 'RetrospectiveEdit'
  hasNoDf?: boolean
}

export interface ClinicFeeType {
  clinicFeeId: number
  clinicFeeText: string
  operativeClinicFeeId: number
  operativeId: number
  price: number
}

export interface IOperative {
  price: number
  qty: number
  discount: number
  discountUnit: CURRENCY_UNIT
  additional: number
  additionalUnit: CURRENCY_UNIT
  dfUnit: CURRENCY_UNIT
  dfAmount: number
  dfDiscountAmount: number
  dfDiscountUnit: CURRENCY_UNIT
  dfAmountNet: number
  cfAmount: number
  cfDiscountAmount: number
  cfDiscountUnit: CURRENCY_UNIT
  cfAmountNet: number
  dfRemark?: string
  total: number
  doctorFeeAmount?: number
  clinicFeeAmount?: number
  clinicFeeId?: number
  clinicFeeName?: string
  clinicFeeNameEn?: string
  clinicFeePrice?: number
}

export default function PopupManageTreatmentCourse(props: IPopupManageTreatmentCourse) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const location = useLocation()
  const modal: boolean = useSelector(modalSlice.handleShow)
  const treatments: TreatmentStateInterface = useSelector(treatment)
  const user = useSelector(selectMe)
  const promotions = useSelector(promotionsTreatments)
  const [loading, setLoading] = useState(false)
  const [doctorFee, setDoctorFee]: any = useState({})
  const [operative, setOperative]: any = useState({})
  const [operativeCurrent, setOperativeCurrent] = useState<any>({})
  const [operativeOld, setOperativeOld] = useState<any>({})
  const [statusLoadFirstOp, setStatusLoadFirstOp] = useState<boolean>(true)
  const units: CURRENCY_UNIT[] = [CURRENCY_UNIT.PERCENT, CURRENCY_UNIT.BAHT]

  const [normalPrice, setNormalPrice] = useState(0)

  const [discountAmount, setDiscountAmount] = useState(0)
  const [amount, setAmount] = useState(0)

  const [df, setDf] = useState(0)
  const [cf, setCf] = useState(0)
  const [dfDiscountAmount, setDfDiscountAmount] = useState(0)
  const [cfDiscountAmount, setCfDiscountAmount] = useState(0)

  const [clinicFees, setClinicFees] = useState<any>([])

  const [disabled, setDisabled] = useState(false)

  const [errorMessage, setErrorMessage] = useState({
    PRICE: '',
    QTY: ''
  })
  const [isFocus, setIsFocus] = useState<string>('')

  const [approval, setApproval] = useState<boolean>(false)
  const [isDisabledChange, setIsDisabledChange] = useState<boolean>(false)
  const approvalRight = useSelector(checkApprovalRight)

  const [outToken, setOutToken] = useState<boolean>(false)
  const search = window.location.search;
  const params = new URLSearchParams(search);

  const [popPromotionExtra, setPopPromotionExtra] = useState<boolean>(false)


  const branchInfo = getClinicInfo()
  const [disabledSave, setDisabledSave] = useState<boolean>(false)
  const [isPromtion, setIsPromotion] = useState<boolean>(false)

  const [voucherLoadClear, setVoucherLoadClear] = useState<boolean>(false)
  const [voucherOperative, setVoucherOperative] = useState<any>({})
  const [vouchers, setVoucher] = useState<any>({})
  const [popVoucherSelectLot, setPopVoucherSelectLot] = useState<boolean>(false)
  const [dataPopVoucherSelectLot, setDataPopVoucherSelectLot] = useState<any>({})
  const [searchVoucher, setSearchVoucher] = useState<string>("")
  const [errorSearchVoucher, setErrorSearchVoucher] = useState<string>("")

  /** Promotion */
  const [promotion, setPromotion] = useState<{ list: any, used: any, current: any, extraCurrent: any, extraList: any, package: any, tempTreatments: any }>({ list: [], used: [], current: {}, extraCurrent: [], extraList: [], package: [], tempTreatments: [] })


  const [operativeTotal, setOperativeTotal] = useState<number>(0)
  const paymentInstallmentOption = [
    { name: t('TREATMENT_COURSE.FORM.PAYMENT.PAYMENT_METHOD_FULL'), value: "0" },
    { name: t('TREATMENT_COURSE.FORM.PAYMENT.PAYMENT_METHOD_LNSTALLMENT'), value: "1", disabled: operative.dfDiscountAmount !== 0 && operative.dfDiscountAmount !== "0" || operative.cfDiscountAmount !== 0 && operative.cfDiscountAmount !== "0" }
  ]
  const [paymentInstallment, setPaymentInstallment] = useState<string>("0")
  const [paymentInstallmentList, setPaymentInstallmentList] = useState<PaymentInstallmentListProps[]>([
    { paidDate: moment().format('YYYY-MM-DD'), optionPrice: PERCENT_OP.AVERAGE, price: (operative.total || 0) / 2, installmentNumber: 1, status: PaymentInstallmentListStatus.PENDING, installmentId: null },
    { paidDate: '', optionPrice: PERCENT_OP.AVERAGE, price: (operative.total || 0) / 2, installmentNumber: 2, status: PaymentInstallmentListStatus.PENDING, installmentId: null },
  ])
  const [isPaymentInstallmentLoad, setIsPaymentInstallmentLoad] = useState<boolean>(false)

  const containerModalRef = useRef<HTMLDivElement>(null)
  const isPackage = getPackage()

  const [openModal, setOpenModal] = useState(false);
  const [hasSignature, setHasSignature] = useState(false);

  const loadCheckApprovePermiss = async () => {
    await ApprovalApi.checkApprovePermiss().then(({ data }) => {
      if (data) {
        dispatch(setApprovalRight(data))
      }
    })
  }

  const loadAboutClinic = async () => {
    const resp = await TreatmentsAPI.findInvoiceTreatment(props.patient?.patientCaseId).finally(() => setLoading(false));
    setHasSignature(resp.data[0]?.invoice?.doctorSignature && resp.data[0]?.invoice?.patientSignature)
  }

  useEffect(() => {
    if (!props.noModal && !params.get('token')) {
      loadCheckApprovePermiss()
    }
    loadAboutClinic()
  }, [])

  useEffect(() => {
    const newLocation: any = location?.state
    if (newLocation) {
      const { approval } = newLocation
      setApproval(approval)
    } else {
      setApproval(false)
    }

    if (location?.search) {
      setOutToken(true)
    }

    if (['/treatments', '/payment/create', 'retrospective-order'].includes(location?.pathname)) {
      setIsPromotion(true)
    }

  }, [location])

  useEffect(() => {
    if (statusLoadFirstOp && operative?.doctorFeeAmount) {
      setOperativeCurrent(operative)
      setStatusLoadFirstOp(false)
    }
  }, [operative])

  const loadDoctorFee = async (doctorId: number, operativeId: number) => {
    if (operativeId && !params.get('token')) {
      setLoading(true)
      const condition: FindDoctorFeeProps = {
        operativeId: operativeId,
        branchId: Number(getBranch()),
        doctorId: doctorId
      }
      const resp = await TreatmentApi.findDoctorFee(condition)
      if (resp.status === 200) setDoctorFee(resp.data)
    } else {
      const condition: FindDoctorFeeProps = {
        operativeId: operativeId,
        branchId: props?.branchId || 0,
        doctorId: doctorId
      }
      const resp = await ApprovalApi.findApprovalOperativeById(condition)
      if (resp.status === 200) setDoctorFee(resp.data)
      setLoading(false)
    }
  }

  const loadOperativeById = async (operativeId: number) => {
    if (operativeId && !params.get('token')) {
      const resp: any = await OperativeApi.findById(operativeId).finally(() => setLoading(false))
      if (resp.status === 200) setClinicFees(resp.data?.operativeClinicFees)
    }
  }

  useEffect(() => {
    if (clinicFees[0]) {
      setOperative({
        ...operative,
        clinicFeeId: clinicFees[0]?.clinicFeeId,
        clinicFeeName: clinicFees[0]?.clinicFeeText,
        clinicFeePrice: clinicFees[0]?.price
      })
      setOperativeCurrent({
        ...operativeCurrent,
        clinicFeeId: clinicFees[0]?.clinicFeeId,
        clinicFeeName: clinicFees[0]?.clinicFeeText,
        clinicFeePrice: clinicFees[0]?.price
      })
    }
  }, [clinicFees])


  useEffect(() => {
    let promotionList: any = []
    if (promotions?.length && operative?.operativeId) {
      const vouchers = promotions.find((item: any) => item?.itemId === operative?.operativeId)?.vouchers || []
      setVoucher(vouchers)
      promotionList = promotions.find((item: any) => item?.itemId === operative?.operativeId)?.promotions || []

    }
    const pro = _.find(operative?.promotion, { isMain: "1" })
    let extra = _.find(promotionList, { promotionBranchId: pro?.promotionBranchId })
    if (extra) extra = _.filter(extra.extra, { type: 'EXTRA' })
    setPromotion((val) => ({ ...val, current: pro || {}, list: promotionList, extraCurrent: extra || [] }))
  }, [promotions])

  const onLoadPromotionTreatments = () => {
    const patientId = treatments?.summeryTreatments?.find((item: any) => item?.patientId)?.patientId || 0
    if ((props?.itemId || props?.itemId === 0) && (props?.patient?.patientId || patientId) && operative?.operativeId) {
      const summaryTreatments = _.merge([], treatments.summeryTreatments)
      summaryTreatments[props.itemId] = operative
      dispatch(loadPromotionTreatments(props?.patient?.patientId || patientId, summaryTreatments))
    }
  }

  useEffect(() => {
    if ((!isNaN(operative?.total) && operative?.total !== 0) || operative?.qty === 0) {
      onLoadPromotionTreatments()
    }

  }, [operative?.total, operative?.qty])



  const handleCheckApproval = () => {
    if (isPackage?.package !== 'ULTRA') {
      return false
    }
    const { qty,
      dfAmount,
      cfAmount,
      dfAmountNet,
      cfAmountNet,
      doctorFeeAmount,
      clinicFeeAmount,
      total, dfRemark, promotion,
      promotionDiscount,
      promotionDiscountUnit,
      dfPromotionDiscountAmount,
      dfPromotionDiscountUnit,
      cfPromotionDiscountAmount,
      cfPromotionDiscountUnit,
      voucherDiscount,
      voucherDiscountUnit,
      dfVoucherDiscountAmount,
      dfVoucherDiscountUnit,
      cfVoucherDiscountAmount,
      cfVoucherDiscountUnit,
      voucher,
      voucherListId,
      promotionPriceType,
      promotionUsage,
      voucherPriceType,
      voucherUsage,
      dfUnit,
      dfAmounNet,
      fullPrice,
      ...dataOfOperative } = operative
    const {
      qty: qtyCurrent,
      dfAmount: dfAmountCr,
      cfAmount: cfAmountCr,
      dfAmountNet: dfAmountNetCr,
      cfAmountNet: cfAmountNetCr,
      doctorFeeAmount: doctorFeeAmountCr,
      clinicFeeAmount: clinicFeeAmountCr,
      total: totalCr,
      dfRemark: dfRemarkCr,
      promotion: promotionCr,
      promotionDiscount: promotionDiscountCr,
      promotionDiscountUnit: promotionDiscountUnitCr,
      dfPromotionDiscountAmount: dfPromotionDiscountAmountCr,
      dfPromotionDiscountUnit: dfPromotionDiscountUnitCr,
      cfPromotionDiscountAmount: cfPromotionDiscountAmountCr,
      cfPromotionDiscountUnit: cfPromotionDiscountUnitCr,
      voucherDiscount: voucherDiscountCr,
      voucherDiscountUnit: voucherDiscountUnitCr,
      dfVoucherDiscountAmount: dfVoucherDiscountAmountCr,
      dfVoucherDiscountUnit: dfVoucherDiscountUnitCr,
      cfVoucherDiscountAmount: cfVoucherDiscountAmountCr,
      cfVoucherDiscountUnit: cfVoucherDiscountUnitCr,
      voucher: voucherCr,
      voucherListId: voucherListIdCr,
      promotionPriceType: promotionPriceTypeCr,
      promotionUsage: promotionUsageCr,
      voucherPriceType: voucherPriceTypeCr,
      voucherUsage: voucherUsageCr,
      dfUnit: dfUnitCr,
      dfAmounNet: dfAmounNetCr,
      fullPrice: fullPriceCr,
      ...dataOfOperativeCurrent
    } = operativeCurrent;
    const discount = dataOfOperative.discountUnit === 'BAHT' ? dataOfOperative?.discount : dataOfOperative?.price * dataOfOperative?.discount / 100
    const additional = dataOfOperative.additionalUnit === 'BAHT' ? dataOfOperative?.additional : dataOfOperative?.price * dataOfOperative?.additional / 100
    const discountCurrent = dataOfOperativeCurrent.discountUnit === 'BAHT' ? dataOfOperativeCurrent?.discount : dataOfOperativeCurrent?.price * dataOfOperativeCurrent?.discount / 100
    const additionalCurrent = dataOfOperativeCurrent.additionalUnit === 'BAHT' ? dataOfOperativeCurrent?.additional : dataOfOperativeCurrent?.price * dataOfOperativeCurrent?.additional / 100
    const discountDF = dataOfOperative?.dfDiscountUnit === 'BAHT' ? Number(dataOfOperative?.dfDiscountAmount) : df * Number(dataOfOperative?.dfDiscountAmount) / 100
    const discountCF = dataOfOperative?.cfDiscountUnit === 'BAHT' ? Number(dataOfOperative?.cfDiscountAmount) : cf * Number(dataOfOperative?.cfDiscountAmount) / 100
    const discountDFCurrent = dataOfOperativeCurrent?.dfDiscountUnit === 'BAHT' ? Number(dataOfOperativeCurrent?.dfDiscountAmount) : df * Number(dataOfOperativeCurrent?.dfDiscountAmount) / 100
    const discountCFCurrent = dataOfOperativeCurrent?.cfDiscountUnit === 'BAHT' ? Number(dataOfOperativeCurrent?.cfDiscountAmount) : cf * Number(dataOfOperativeCurrent?.cfDiscountAmount) / 100
    if (dataOfOperative?.price !== dataOfOperativeCurrent?.price) return true
    if (discount !== discountCurrent || additional !== additionalCurrent) return true
    if (discountDF !== discountDFCurrent || discountCF !== discountCFCurrent) return true
    return false
  }


  const handleInstallmentCheck = () => {
    if (paymentInstallment !== '1') {
      return null
    }
    const totalInstallmentList = Math.round(_.sumBy(paymentInstallmentList, (v) => {
      return Number((v?.price || 0).toFixed(2))
    }) * 100) / 100;

    if (operativeTotal !== totalInstallmentList) {
      notiError(t('INSTALLMENT.POPUP_MANAGE_TREATMENT.MESSAGE.ERROR.TOTAL_INSTALLMENT'))
      return null
    }
    const newInstallmentOp = {
      totalPrice: operativeTotal,
      installmentItemPrice: operative?.price,
    }
    return {
      totalPrice: operativeTotal,
      refType: "TEMP_ORDER",
      installmentItemPrice: operative?.price,
      ...operativeCurrent?.installment,
      ...(operativeCurrent?.installment?.refType === "TEMP_ORDER" ? newInstallmentOp : {}),
      installmentList: _.map(paymentInstallmentList, (item, index) => ({ ...item, installmentNumber: index + 1 }))
    }

  }

  const handleSubmit = async () => {
    // setDisabledSave(true)
    const newLocation: any = location
    const checkSave = (newLocation?.pathname === '/payment/create' || newLocation?.pathname === '/treatments' || newLocation?.pathname === '/retrospective-order')

    const dataInstallment = handleInstallmentCheck()
    if (paymentInstallment === '1' && !dataInstallment) {
      setDisabledSave(false)
      return
    }

    if ((!operative.price && operative.price !== 0) || !operative.qty) {
      setDisabledSave(false)
      return setErrorMessage({ PRICE: !operative.price ? t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.ERROR.EMPTY_PRICE') : '', QTY: !operative.qty ? t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.ERROR.EMPTY_QTY') : '' })
    }

    const newPrice = (dataInstallment && dataInstallment?.installmentList?.length) ? operative?.total : operative?.price

    const { dataTreatmentsPromotions: newOperatives, errorExtra, newBuy, newExtra, errorBuy } = await onPromotionSave({
      patient: props?.patient,
      promotionExtraBuy: promotion.tempTreatments,
      promotionExtraNew: promotion.extraCurrent,
      promotionExtraValue: promotion.current,
      dataPromotions: promotion.current?.promotionBranchId ? { ...operative, index: props.itemId } : null,
      treatments,
      user,
      t: t
    })

    if (errorExtra || errorBuy) {
      setDisabledSave(false)
      return
    }
    const operatives = [...newOperatives]
    if (props.itemId || props.itemId === 0) operatives[props.itemId] = {
      ...operative,
      price: newPrice,
      isReload: promotion?.current || voucherLoadClear || isPaymentInstallmentLoad,
      promotion: promotion?.current?.promotionBranchId ? [promotion?.current, ...promotion.tempTreatments, ...promotion.extraCurrent] : null,
      voucherListId: operative?.voucherListId || 0,
      installment: dataInstallment
    }



    if (checkSave && (props.itemId || props.itemId === 0) && handleCheckApproval() && approvalRight?.hasChangeCost) {
      const { approvalItems, ...newObjBodyData } = operativeCurrent
      const { approvalItems: _, ...newObjNewBodyData } = operative
      operatives[props.itemId] = {
        ...operatives[props.itemId],
        isChangeCost: "1",
        bodyData: JSON.stringify(newObjBodyData),
        newBodyData: JSON.stringify(newObjNewBodyData),
        requestReason: "",
        isReload: promotion?.current || voucherLoadClear || isPaymentInstallmentLoad
      }
      swalCustom(
        t('APPROVELLIST.FILTER.PENDING'),
        `<div style="width: 350px"> ${t('APPROVELLIST.MESSAGE.PENDING_')}  </div>`,
        (res: any) => console.log(),
        'warning',
        {
          confirmButton: { showConfirmButton: false },
          cancelButton: { cancelButtonText: t('BUTTON.ENTER') },
          showCloseButton: false,
          containerClass: 'swal-change-cost'
        }
      )
      dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: [...operatives, ...newExtra, ...newBuy] }))
      dispatch(modalSlice.resetModal())
      setDisabledSave(false)
    } else {
      dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: [...operatives, ...newExtra, ...newBuy] }))
      dispatch(modalSlice.resetModal())
      setDisabledSave(false)
    }
  }




  const handleChange = async (e: any) => {
    const name = e.target.name
    setVoucherOperative({})
    // ปิดเพราะไม่งั้น GV หลุด
    setSearchVoucher("")
    const checkNaN = () => {
      if (!isNaN(Number(String(e.target.value).replace(/[^0-9.]/g, '')))) {
        if (name === 'qty') {
          return Number(String(e.target.value).replace(/[^0-9.]/g, ''))
        }
        return String(e.target.value).replace(/[^0-9.]/g, '')
      } else {
        return Number('')
      }
    }
    const value = name === 'price' || name === 'qty' || name === 'discount' || name === 'additional' || name === 'dfDiscountAmount' || name === 'cfDiscountAmount' ? checkNaN() : e.target.value

    // name === 'qty' && setPromotionOperative(promotionOperative?.filter((item: any) => item?.isMain !== "1"))

    setErrorMessage({ PRICE: '', QTY: '' })
    if (
      (name === 'discount' && operative.discountUnit === CURRENCY_UNIT.BAHT) ||
      (name === 'additional' && operative.additionalUnit === CURRENCY_UNIT.BAHT) ||
      (name === 'dfDiscountAmount' && operative.dfDiscountUnit === CURRENCY_UNIT.BAHT) ||
      (name === 'cfDiscountAmount' && operative.cfDiscountUnit === CURRENCY_UNIT.BAHT)
    ) {
      return handleChangeDiscountPriceCurrency(name, value)
    } else if (
      (name === 'discount' && operative.discountUnit === CURRENCY_UNIT.PERCENT) ||
      (name === 'additional' && operative.additionalUnit === CURRENCY_UNIT.PERCENT) ||
      (name === 'dfDiscountAmount' && operative.dfDiscountUnit === CURRENCY_UNIT.PERCENT) ||
      (name === 'cfDiscountAmount' && operative.cfDiscountUnit === CURRENCY_UNIT.PERCENT)
    ) {
      return handleChangeDiscountPercent(name, value)
    } else if ((name === 'discountUnit' || name === 'additionalUnit' || name === 'dfDiscountUnit' || name === 'cfDiscountUnit') && value === CURRENCY_UNIT.PERCENT) {
      return handleChangeDiscountUnitToPercent(name, value)
    } else {
      let newValue = e.target.value
      newValue = newValue.replace(/[^0-9.]/g, '');
      if (newValue.indexOf('.') !== newValue.lastIndexOf('.')) {
        newValue = newValue.slice(0, newValue.lastIndexOf('.'));
      }
      if (operative.refType === "COURSE" && name === 'qty') {
        const inputValue = Number(newValue)
        const resp = await TreatmentApi.getTxc(Number(props.patient?.patientId))
        if (resp.status === 200) {
          const arrayPatientTreatmentCourse = _.find(resp.data, (item) => item?.patientTreatmentCourseId === operative?.patientTreatmentCourseId)
          const treatmentCourse = _.find(arrayPatientTreatmentCourse?.patientTreatmentCourseItems, (item) => item?.itemId === operative?.operativeId)
          const totalQty = treatments.summeryTreatments.filter((item: any, index: number) => item.operativeId === operative?.operativeId && index !== props.itemId && item.patientTreatmentCourseId === operative?.patientTreatmentCourseId).reduce((sum: number, item: any) => sum + item.qty, 0) || 0
          const remainingQty = Math.max(treatmentCourse?.balance - totalQty, 0);
          const finalQty = inputValue > remainingQty ? remainingQty : inputValue;
          setOperative({ ...operative, qty: finalQty })
        }
      } else {
        setOperative({ ...operative, [name]: e.target.type === 'number' && value < 0 && value !== '' ? (name === 'qty' && 1) || 0 : value, })
      }
    }
  }

  const handleChangeDiscountPriceCurrency = (name: 'dfDiscountAmount' | 'cfDiscountAmount', val: number | string) => {
    const preValue = String(val).replace(/[^0-9.]/g, '') || ''
    const checkNaN = () => {
      if (!isNaN(Number(preValue))) {
        return preValue
      } else {
        return Number('')
      }
    }
    const value = preValue !== '' ? checkNaN() : Number('')
    let obj = {}
    if (name === 'dfDiscountAmount') {
      obj = { [name]: Number(value) >= df ? df : value }
    } else if (name === 'cfDiscountAmount') {
      obj = { [name]: Number(value) >= cf ? String(cf) : String(value) }
    } else {
      obj = { [name]: (value) }
    }
    setOperative({ ...operative, ...obj })
  }

  const handleChangeDiscountPercent = (name: 'discount' | 'additional' | 'dfDiscountAmount' | 'cfDiscountAmount', val: number | string) => {
    const preValue = String(val).replace(/[^0-9.]/g, '') || ''
    const value = preValue !== '' ? preValue : Number('')
    setOperative({ ...operative, [name]: Number(value) >= 100 ? 100 : Number(value) })
  }

  const handleChangeDiscountUnitToPercent = (name: 'discountUnit' | 'additionalUnit' | 'dfDiscountUnit' | 'cfDiscountUnit', value: CURRENCY_UNIT.PERCENT) => {
    let obj = {}
    if (name === 'discountUnit') obj = { [name]: value, discount: operative?.discount >= 100 ? 100 : operative?.discount }
    else if (name === 'dfDiscountUnit') obj = { [name]: value, dfDiscountAmount: operative?.dfDiscountAmount >= 100 ? 100 : operative?.dfDiscountAmount }
    else if (name === 'cfDiscountUnit') obj = { [name]: value, cfDiscountAmount: operative?.cfDiscountAmount >= 100 ? 100 : operative?.cfDiscountAmount }
    else obj = { [name]: value, additional: operative?.additional >= 100 ? 100 : operative?.additional }

    setOperative({ ...operative, ...obj })
  }

  useEffect(() => {
    setErrorSearchVoucher("")
    setDisabled(true)
    calOperativeTotal()
    setDisabled(false)

  }, [
    operative.price, operative.qty,
    operative.discount, operative.discountUnit,
    operative.additional, operative.additionalUnit,
    doctorFee, operative.dfDiscountAmount,
    operative.dfDiscountUnit, operative.cfDiscountAmount,
    operative.cfDiscountUnit,
    promotion?.current,
    voucherOperative
  ])


  const calOperativeTotal = useCallback(() => {
    const price = Number(operative.price)
    const qty = Number(operative.qty)
    const newNormalPrice = price * qty

    setNormalPrice(newNormalPrice)
    const rawDiscount = Number(operative.discount)
    const rawDiscountUnit = operative.discountUnit
    const rawAdditional = Number(operative.additional)
    const rawAdditionalUnit = operative.additionalUnit

    const newOpPromotion: any = promotion?.current
    const rawPromotionType = newOpPromotion?.type || ""
    const rawPromotionPriceType = newOpPromotion?.promotionPriceType || ""
    const rawPromotionUsage = newOpPromotion?.promotionUsage || ""
    const rawPromotionDiscount = Number(newOpPromotion?.promotionPrice || 0)
    const rawPromotionDiscountUnit = newOpPromotion?.promotionPriceUnit || CURRENCY_UNIT.BAHT

    const rawVoucherPriceType = voucherOperative?.voucherPriceType || ""
    const rawVoucherUsage = voucherOperative?.voucherUsage || ""
    const rawVoucherDiscount = Number(voucherOperative?.voucherPrice || 0)
    const rawVoucherDiscountUnit = voucherOperative?.voucherPriceUnit || CURRENCY_UNIT.BAHT

    let rawDiscountAmount = 0
    let rawAdditionalAmount = 0
    let rawPromotionDiscountAmount = 0
    let rawVoucherDiscountAmount = 0

    /** คำนวน ส่วนลดส่วนเพิ่มจากราคาเต็ม */

    /** ส่วนลด ทั่วไป */
    if (rawDiscountUnit === CURRENCY_UNIT.PERCENT) rawDiscountAmount = newNormalPrice * (rawDiscount / 100)
    if (rawDiscountUnit === CURRENCY_UNIT.BAHT) rawDiscountAmount = rawDiscount

    /** ส่วนเพิ่ม */
    if (rawAdditionalUnit === CURRENCY_UNIT.PERCENT) rawAdditionalAmount = newNormalPrice * (rawAdditional / 100)
    if (rawAdditionalUnit === CURRENCY_UNIT.BAHT) rawAdditionalAmount = rawAdditional

    /** ส่วนลด Promotion */
    if (rawPromotionType === 'DISCOUNT' && rawPromotionPriceType === 'DISCOUNT' && rawPromotionDiscountUnit === CURRENCY_UNIT.PERCENT) rawPromotionDiscountAmount = newNormalPrice * (rawPromotionDiscount / 100)
    if (rawPromotionType === 'DISCOUNT' && rawPromotionPriceType === 'DISCOUNT' && rawPromotionDiscountUnit === CURRENCY_UNIT.BAHT) rawPromotionDiscountAmount = rawPromotionDiscount
    if (rawPromotionType === 'DISCOUNT' && rawPromotionPriceType === 'SALEPRICE') {
      rawPromotionDiscountAmount = newNormalPrice - rawPromotionDiscount
      // newNormalPrice = rawPromotionDiscount
    }
    /** ส่วนลด Voucher */
    if (rawVoucherPriceType === 'DISCOUNT' && rawVoucherDiscountUnit === CURRENCY_UNIT.PERCENT) rawVoucherDiscountAmount = newNormalPrice * (rawVoucherDiscount / 100)
    if (rawVoucherPriceType === 'DISCOUNT' && rawVoucherDiscountUnit === CURRENCY_UNIT.BAHT) rawVoucherDiscountAmount = rawVoucherDiscount

    if (rawVoucherPriceType === 'SALEPRICE') {
      rawVoucherDiscountAmount = newNormalPrice - rawVoucherDiscount
      // newNormalPrice = rawVoucherDiscount
    }

    setDiscountAmount(rawDiscountAmount)

    /** 
     *? ราคาหลังหักส่วนลด-ส่วนเพิ่ม 
     */
    let newAmount = newNormalPrice - rawDiscountAmount + rawAdditionalAmount
    const fullPrice = newAmount
    let newDF = 0
    let newCF = 0
    let total = newAmount || 0
    let totalOperative = newAmount
    let dfAmount = doctorFee.dfAmount;
    let cfAmount = doctorFee.cfAmount
    let doctorFeeAmount = doctorFee.dfAmount
    let clinicFeeAmount = doctorFee.clinicFeeAmount
    let dfUnit = doctorFee.dfUnit
    let cfUnit = doctorFee.cfUnit
    let dfAmounNet = doctorFee.dfAmounNet

    let valueDf = 0
    let valueCf = 0
    /** ได้ DF CF จากราคาสุทธิ (คิด ส่วนลด-ส่วนเพิ่ม)  */
    /** 
     *? คำนวน DF
     *? กรณี หัตถการเฉพาะ DF
     *? กรณี หัตถการเฉพาะ CF
     *? หัตถการทั้ง DF และ CF
     */
    if (price === 0 && doctorFee.dfUnit !== CURRENCY_UNIT.PERCENT) {
      const sumDf = doctorFee.dfAmount
      newDF = sumDf
      newCF = 0
      const newValueDf = (total <= 0 && props.hasNoDf) ? 0 : sumDf * qty
      valueDf = newValueDf
      valueCf = 0

      dfAmounNet = sumDf * qty
      dfAmount = sumDf
      cfAmount = 0
      doctorFeeAmount = sumDf
      clinicFeeAmount = 0
      dfUnit = doctorFee.dfUnit

      /** ราคาหลังหัก Promotion && Voucher */
      setAmount(newAmount)
      setOperativeTotal(totalOperative)

      setDf(valueDf)
      setCf(valueCf)

      setOperative((val: any) => ({
        ...val,
        total: total >= 0 ? total : 0,
        dfAmountNet: (total <= 0 && props.hasNoDf) ? 0 : (dfAmounNet > 0 ? dfAmounNet : 0),
        cfAmountNet: valueCf > 0 ? valueCf : 0,
        dfAmount: (total <= 0 && props.hasNoDf) ? 0 : dfAmount,
        cfAmount,
        doctorFeeAmount,
        clinicFeeAmount,
        dfUnit,
        dfAmounNet,
        fullPrice,
      }))
    } else {


      if (doctorFee.dfUnit === CURRENCY_UNIT.PERCENT) {
        const sumDf = total * (doctorFee.dfAmount / 100)
        const sumCf = total * (doctorFee.cfAmount / 100)
        newDF = sumDf
        newCF = sumCf
        valueDf = sumDf
        valueCf = sumCf

        dfAmount = doctorFee.dfAmount
        cfAmount = doctorFee.cfAmount
        doctorFeeAmount = valueDf
        clinicFeeAmount = valueCf
        dfUnit = doctorFee.dfUnit
      } else {
        newDF = doctorFee.dfAmount * qty
        newCF = total - (doctorFee.dfAmount * qty)
        const newValueDf = (total <= 0 && props.hasNoDf) ? 0 : newDF
        valueDf = newValueDf
        valueCf = newCF

        dfAmount = doctorFee.dfAmount
        cfAmount = doctorFee.cfAmount
        doctorFeeAmount = valueDf
        clinicFeeAmount = valueCf
        dfUnit = doctorFee.dfUnit
        cfUnit = doctorFee.cfUnit
      }



      let rawDfDiscountAmount = 0
      let rawCfDiscountAmount = 0

      if (operative.dfDiscountUnit === CURRENCY_UNIT.PERCENT) {
        rawDfDiscountAmount = (Number(valueDf) * Number(operative.dfDiscountAmount)) / 100
        setDfDiscountAmount(rawDfDiscountAmount)
      } else if (operative.dfDiscountUnit === CURRENCY_UNIT.BAHT) {
        rawDfDiscountAmount = Number(operative.dfDiscountAmount)
        setDfDiscountAmount(rawDfDiscountAmount)
      }

      if (operative.cfDiscountUnit === CURRENCY_UNIT.PERCENT) {
        rawCfDiscountAmount = (Number(valueCf) * Number(operative.cfDiscountAmount)) / 100
        setCfDiscountAmount(rawCfDiscountAmount)
      } else if (operative.cfDiscountUnit === CURRENCY_UNIT.BAHT) {
        rawCfDiscountAmount = Number(operative.cfDiscountAmount)
        setCfDiscountAmount(Number(operative.cfDiscountAmount))
      }

      let dfAmountBaht = valueDf
      let cfAmountBaht = valueCf
      const dfAmountBahtFix = valueDf
      const cfAmountBahtFix = valueCf

      valueDf = valueDf - rawDfDiscountAmount
      valueCf = valueCf - rawCfDiscountAmount
      doctorFeeAmount = doctorFeeAmount - rawDfDiscountAmount
      clinicFeeAmount = clinicFeeAmount - rawCfDiscountAmount

      newAmount = newAmount - rawDfDiscountAmount - rawCfDiscountAmount

      let dfAmountNet = valueDf
      let cfAmountNet = valueCf
      let dfPromotionDiscountAmount = 0
      let cfPromotionDiscountAmount = 0
      let dfVoucherDiscountAmount = 0
      let cfVoucherDiscountAmount = 0

      /** Promotion */

      if (rawPromotionType === "DISCOUNT") {
        if (rawPromotionDiscountAmount > 0 && rawPromotionUsage === 'OPERATIVEDF') {
          dfPromotionDiscountAmount = rawPromotionDiscountAmount

          valueDf = valueDf - rawPromotionDiscountAmount
          doctorFeeAmount = doctorFeeAmount - rawPromotionDiscountAmount

          dfAmountBaht = dfAmountBaht - rawPromotionDiscountAmount
        }
        if (rawPromotionDiscountAmount > 0 && rawPromotionUsage === 'OPERATIVECF') {
          cfPromotionDiscountAmount = rawPromotionDiscountAmount

          valueCf = valueCf - rawPromotionDiscountAmount
          clinicFeeAmount = clinicFeeAmount - rawPromotionDiscountAmount

          cfAmountBaht = cfAmountBaht - rawPromotionDiscountAmount
        }

        if (rawPromotionDiscountAmount > 0 && rawPromotionUsage === 'OPERATIVE') {

          dfPromotionDiscountAmount = ((dfAmountBahtFix / total) * rawPromotionDiscountAmount)
          cfPromotionDiscountAmount = ((cfAmountBahtFix / total) * rawPromotionDiscountAmount)

          valueDf = valueDf - ((dfAmountBahtFix / total) * rawPromotionDiscountAmount)
          valueCf = valueCf - ((cfAmountBahtFix / total) * rawPromotionDiscountAmount)
          doctorFeeAmount = doctorFeeAmount - ((dfAmountBahtFix / total) * rawPromotionDiscountAmount)
          clinicFeeAmount = clinicFeeAmount - ((cfAmountBahtFix / total) * rawPromotionDiscountAmount)

          dfAmountBaht = dfAmountBaht - ((dfAmountBahtFix / total) * rawPromotionDiscountAmount)
          cfAmountBaht = cfAmountBaht - ((cfAmountBahtFix / total) * rawPromotionDiscountAmount)
        }
      }


      /** Voucher */
      if (rawVoucherDiscountAmount > 0 && rawVoucherUsage === 'OPERATIVEDF') {
        dfVoucherDiscountAmount = rawVoucherDiscountAmount

        valueDf = valueDf - rawVoucherDiscountAmount
        doctorFeeAmount = doctorFeeAmount - rawVoucherDiscountAmount

        dfAmountBaht = dfAmountBaht - rawVoucherDiscountAmount
      }
      if (rawVoucherDiscountAmount > 0 && rawVoucherUsage === 'OPERATIVECF') {
        cfVoucherDiscountAmount = rawVoucherDiscountAmount

        valueCf = valueCf - rawVoucherDiscountAmount
        clinicFeeAmount = clinicFeeAmount - rawVoucherDiscountAmount

        cfAmountBaht = cfAmountBaht - rawVoucherDiscountAmount
      }

      if (rawVoucherDiscountAmount > 0 && rawVoucherUsage === 'OPERATIVE') {

        dfVoucherDiscountAmount = ((dfAmountBahtFix / total) * rawVoucherDiscountAmount)
        cfVoucherDiscountAmount = ((cfAmountBahtFix / total) * rawVoucherDiscountAmount)

        valueDf = valueDf - ((dfAmountBahtFix / total) * rawVoucherDiscountAmount)
        valueCf = valueCf - ((cfAmountBahtFix / total) * rawVoucherDiscountAmount)
        doctorFeeAmount = doctorFeeAmount - ((dfAmountBahtFix / total) * rawVoucherDiscountAmount)
        clinicFeeAmount = clinicFeeAmount - ((cfAmountBahtFix / total) * rawVoucherDiscountAmount)

        dfAmountBaht = dfAmountBaht - ((dfAmountBahtFix / total) * rawVoucherDiscountAmount)
        cfAmountBaht = cfAmountBaht - ((cfAmountBahtFix / total) * rawVoucherDiscountAmount)
      }

      const promotionDiscountRow = {
        promotionPriceType: rawPromotionPriceType,
        promotionUsage: rawPromotionUsage,
        promotionDiscount: rawPromotionUsage === 'OPERATIVE' ? (dfPromotionDiscountAmount + cfPromotionDiscountAmount) : 0,
        promotionDiscountUnit: CURRENCY_UNIT.BAHT,
        dfPromotionDiscountAmount: rawPromotionUsage === 'OPERATIVE' ? 0 : dfPromotionDiscountAmount,
        dfPromotionDiscountUnit: CURRENCY_UNIT.BAHT,
        cfPromotionDiscountAmount: rawPromotionUsage === 'OPERATIVE' ? 0 : cfPromotionDiscountAmount,
        cfPromotionDiscountUnit: CURRENCY_UNIT.BAHT,
      }
      const rawPromotionDf = promotionDiscountRow?.dfPromotionDiscountAmount || 0
      const rawPromotionCf = promotionDiscountRow?.cfPromotionDiscountAmount || 0

      const checkVoucher = voucherOperative?.voucherId ? true : false

      const voucherDiscountRow = {
        voucherListId: voucherOperative?.voucherListId || 0,
        voucherPriceType: voucherOperative?.voucherPriceType || '',
        voucherUsage: voucherOperative?.voucherUsage || '',
        voucherDiscount: rawVoucherUsage === 'OPERATIVE' ? (dfVoucherDiscountAmount + cfVoucherDiscountAmount) : 0,
        voucherDiscountUnit: CURRENCY_UNIT.BAHT,
        dfVoucherDiscountAmount: rawVoucherUsage === 'OPERATIVE' ? 0 : dfVoucherDiscountAmount,
        dfVoucherDiscountUnit: CURRENCY_UNIT.BAHT,
        cfVoucherDiscountAmount: rawVoucherUsage === 'OPERATIVE' ? 0 : cfVoucherDiscountAmount,
        cfVoucherDiscountUnit: CURRENCY_UNIT.BAHT,
      }


      newAmount = newAmount - dfPromotionDiscountAmount - cfPromotionDiscountAmount - dfVoucherDiscountAmount - cfVoucherDiscountAmount
      newAmount = newAmount > 0 ? newAmount : 0
      dfAmountBaht = dfAmountBaht > 0 ? dfAmountBaht : 0
      cfAmountBaht = cfAmountBaht > 0 ? cfAmountBaht : 0

      total = newAmount
      totalOperative = newAmount

      doctorFeeAmount = doctorFeeAmount > 0 ? doctorFeeAmount : 0
      clinicFeeAmount = clinicFeeAmount > 0 ? clinicFeeAmount : 0

      dfAmountNet = doctorFeeAmount
      cfAmountNet = clinicFeeAmount

      /** ราคาหลังหัก Promotion && Voucher */
      setAmount(newAmount)
      setOperativeTotal(totalOperative)

      setDf(dfAmountBaht)
      setCf(cfAmountBaht)

      setOperative((val: any) => ({
        ...val,
        total: total >= 0 ? total : 0,
        dfAmountNet: (total <= 0 && props.hasNoDf) ? 0 : (dfAmountNet > 0 ? dfAmountNet : 0),
        cfAmountNet: cfAmountNet > 0 ? cfAmountNet : 0,
        dfAmount: (total <= 0 && props.hasNoDf) ? 0 : dfAmount,
        cfAmount,
        doctorFeeAmount,
        clinicFeeAmount,
        dfUnit,
        dfAmounNet,
        fullPrice,
        ...promotionDiscountRow,
        ...voucherDiscountRow
      }))
    }
  }, [
    operative.price, operative.qty,
    operative.discount, operative.discountUnit,
    operative.additional, operative.additionalUnit,
    doctorFee, operative.dfDiscountAmount,
    operative.dfDiscountUnit, operative.cfDiscountAmount,
    operative.cfDiscountUnit,
    voucherOperative,
    promotion?.current,
  ]);

  useEffect(() => {
    if (!operative.price || operative.price === 0) {
      const newData = { ...operative, discount: 0 }
      setOperative(newData)
    }
  }, [operative.price])


  useEffect(() => {
    if ((modal || props?.noModal) && props.userId) {
      setIsDisabledChange(props.operative?.approvalItems?.status === ApprovalStatus.PENDING)

      const newPrice = props.operative?.installment && props.operative?.installment?.installmentList?.length ? props.operative?.installment?.installmentItemPrice || props.operative?.installment?.totalPrice : props.operative?.price
      const newOperative = { ...props.operative, price: newPrice }

      setOperativeCurrent(newOperative)
      setOperative(newOperative)
      setVoucherOperative(props?.operative?.voucher)
      setSearchVoucher(props?.operative?.voucher?.voucherCode)
      loadDoctorFee(props.userId, props.operative?.operativeId)
      loadOperativeById(props.operative?.operativeId)

      if (props.operative?.installment && props.operative?.installment?.installmentList?.length) {
        setPaymentInstallment("1")
        const newInstallmentList = props.operative?.installment?.installmentList ? props.operative?.installment?.installmentList.map((item: any) => {
          return { ...item, paidDate: item?.paidDate === '0000-00-00' ? '' : item?.paidDate }
        }) : []
        setPaymentInstallmentList(newInstallmentList)
        if (props.operative?.installment?.refType === "ORDER") {
          setIsDisabledChange(true)
          setTimeout(() => {
            handleAutoScrollBottom()
          }, 300)
        }
      }
    } else props.onReset && props.onReset()
  }, [modal])


  useEffect(() => {
    const promotionAll: any = []
    treatments?.summeryTreatments?.forEach((item: any) => {
      if (item?.promotion?.length && item?.promotion?.some((info: any) => info.isMain === '1' && info?.promotionBranchId !== promotion.current?.promotionBranchId)) {
        const newItem = item?.promotion?.find((info: any) => info.isMain === '1' && info?.promotionBranchId !== promotion.current?.promotionBranchId)
        promotionAll.push(newItem?.promotionBranchId)
      }
    })
    setPromotion((val) => ({ ...val, used: promotionAll, }))
  }, [promotion.current])


  const handleBlurInput = () => {
    if (operative[isFocus]) {
      const [num, numDot] = operative[isFocus].toString().split('.')
      if (numDot && numDot.length === 1) {
        operative[isFocus] = `${operative[isFocus]}0`
      }
    }
    setIsFocus('')
  }

  const onClerPopPromotionExtra = () => {
    setPromotion((val) => ({ ...val, extraList: [] }))
    setPopPromotionExtra(false)
  }

  const onChangePromotionExtra = (data: any, dataBuy?: any) => {
    setPromotion((val) => ({ ...val, current: { ...val.current, promotionType: "BUY", isMain: '1', groupNumber: dataBuy[0]?.groupNumber }, extraCurrent: data || [], tempTreatments: dataBuy || [] }))
    onClerPopPromotionExtra()
  }

  const handleChangePromotion = (value: any) => {
    if (value?.promotionBranchId) {
      const items = treatments?.summeryTreatments
      /**
       * ?? ถ้ามีการเลือก Promotion ที่เป็นแถม
       * ?? 1 แถม 1 และยังไม่ add รายการแล้ว Add ได้เลย
       * ?? 1 แถม 1 และ add รายการแล้ว จำนวนเงื่อนไขตรงกัน แถมได้เลย
       * ?? 1 แถม 2 และยังไม่ add รายการแล้ว Add ได้เลย
       * ?? 1 แถม 2 และ add รายการแล้ว จำนวนเงื่อนไขตรงกัน แถมได้เลย
       * ?? 1 แถม 2 และมีตัวเลือกมากกว่า 1 ชุด แสดง popup เพื่อเลือก กดเลือก และยังไม่ add รายการแล้ว Add ได้เลย
       * ?? 1 แถม 2 และมีตัวเลือกมากกว่า 1 ชุด แสดง popup เพื่อเลือก กดเลือก และ add รายการแล้ว จำนวนเงื่อนไขตรงกัน แถมได้เลย
       */
      if (value?.type === "EXTRA" && value?.extra?.length) {
        const newBuy: any[] = []
        const newExtra: any[] = []

        let _ByeOneFree = false
        value?.extra.forEach((item: any) => {
          if (item?.type === "BUY") {
            if (!newBuy[item?.groupNumber - 1]) newBuy[item?.groupNumber - 1] = []
            newBuy[item?.groupNumber - 1].push(item)

            if (newBuy[item?.groupNumber - 1] && newBuy[item?.groupNumber - 1]?.length === 1) _ByeOneFree = true
            else _ByeOneFree = false
          } else {
            if (!newExtra[item?.groupNumber - 1]) newExtra[item?.groupNumber - 1] = []
            newExtra[item?.groupNumber - 1].push(item)

          }
        })

        /** Check Treatment */
        const canUse: any = []
        _.map(newBuy[0], (pro: any) => {
          const checkUse = _.findIndex(items, (item: any) => {
            const itemType = item.operativeId ? "OPERATIVE" : item.group
            const itemId = item.operativeId || item.itemId
            const qty = item.qty
            return Number(pro?.itemId) === Number(itemId) && pro.itemType === itemType && Number(pro.qty) === Number(qty)
          })

          if (checkUse !== -1) canUse.push(checkUse)
        })



        const checkConfirmUse = canUse.length !== newBuy[0].length

        /** 1 แถม 1 */
        if (_ByeOneFree && newBuy.length === 1 && newExtra.length === 1) {

          setPromotion((val) => ({ ...val, current: { ...value, promotionType: 'BUY', isMain: '1' }, extraCurrent: newExtra[0], extraList: [], tempTreatments: [], package: [], }))
        } else if (!_ByeOneFree && newBuy.length === 1 && newExtra.length === 1) {

          /**
           * ถ้า รายการไม่ครบจะขึ้นให้เลือกซื้อเพิ่ม 
           */
          setPromotion((val) => ({ ...val, current: { ...value, promotionType: 'BUY', isMain: '1' }, extraCurrent: [], extraList: checkConfirmUse ? newExtra : [], package: checkConfirmUse ? newBuy : [], tempTreatments: [] }))
          setPopPromotionExtra(true)
        } else {
          setPromotion((val) => ({ ...val, current: { ...value, promotionType: 'BUY', isMain: '1' }, extraCurrent: [], extraList: newExtra, package: checkConfirmUse ? newBuy : [], tempTreatments: [] }))
          setPopPromotionExtra(true)
        }

      } else {
        setPromotion((val) => ({ ...val, current: { ...value, promotionType: 'BUY', isMain: '1' }, extraCurrent: [], extraList: value.extra, package: [], tempTreatments: [], }))
        setOperative({ ...operative, promotion: [{ ...value, promotionType: 'BUY', isMain: '1' }], promotionDiscount: value?.promotionPrice, promotionDiscountUnit: value?.promotionPriceUnit })
      }
    } else {

      setPromotion((val) => ({ ...val, current: {}, extraCurrent: [], extraList: [], package: [], tempTreatments: [], }))
      setOperative((val: any) => ({ ...val, promotion: null, promotionDiscount: 0, promotionDiscountUnit: '' }))

    }
  }

  const renderDetailListExtra = (data: any, index?: number) => {
    if (data?.length) {
      const newText = data.map((item: any, index: number) => {
        return `${item?.itemName || ''} ${item?.qty || 0} ${item?.itemUnitName || ''}`
      })

      return newText.join(', ')
    }

    const newText: string[] = []
    promotion?.extraCurrent.forEach((item: any) => {
      if (item?.type === "EXTRA") {
        newText.push(item?.itemName)
      }
    })
    return newText.join(', ')
    return ''
  }

  const onOpenPopVoucherSelectLot = (item: any) => {
    setDataPopVoucherSelectLot(item)
    setPopVoucherSelectLot(true)
  }

  const onClerPopVoucherSelectLot = () => {
    setDataPopVoucherSelectLot({})
    setPopVoucherSelectLot(false)
  }

  const handleVoucherSelect = (item?: any) => {
    setVoucherLoadClear(true)
    setSearchVoucher(item?.voucherCode || '')
    if (item?.voucherListId) {
      /** Check Duplicate */
      const checkDuplicate = _.find(treatments?.summeryTreatments, (x: any, index: number) => x.voucherListId && Number(x.voucherListId) === Number(item?.voucherListId) && index !== Number(props?.itemId))
      if (checkDuplicate) return notiError(t(`รหัส Voucher นี้ ถูกใช้งานใน Visit นี้ไปแล้ว`))

      setVoucherOperative({ ...dataPopVoucherSelectLot, ...item })
      setOperative((old: any) => ({ ...old, voucherPriceType: item.voucherPriceType, voucherUsage: item.voucherUsage, voucher: item }))
      onClerPopVoucherSelectLot()
    } else {
      setVoucherOperative({})
    }
  }

  const onLoadVoucher = async () => {
    if (searchVoucher && searchVoucher !== '' && voucherOperative?.voucherCode !== searchVoucher) {

      /** Check Duplicate */
      const checkDuplicate = _.find(treatments?.summeryTreatments, (x: any, index: number) => x?.voucherListId && x?.voucher?.voucherCode === searchVoucher && index !== Number(props?.itemId))
      if (checkDuplicate) return notiError(t(`รหัส Voucher นี้ ถูกใช้งานใน Visit นี้ไปแล้ว`))

      const patientId = treatments?.summeryTreatments?.find((item: any) => item?.patientId)?.patientId || 0
      const newTreatment = [...treatments?.summeryTreatments?.filter((item: any) => item?.operativeId !== operative?.operativeId && (!item?.promotion?.length || item?.promotion.every((info: any) => info?.promotionType !== 'EXTRA'))), operative]
      const condition: VoucherFindByCodeProps = {
        code: searchVoucher,
        itemType: "OPERATIVE",
        itemId: operative?.operativeId || 0,
        qty: operative?.qty,
        min: _.sumBy(newTreatment.map((item: any) => {
          if (item?.approvalItems?.status === ApprovalStatus.PENDING) {
            const newData = JSON.parse(item?.approvalItems?.body)
            return { ...item, total: newData?.total }
          } else {
            return { ...item }
          }
        }), 'total'),
        patientId: props?.patient?.patientId || patientId
      }
      await VoucherApi.findVoucherByCode(condition).then((res) => {
        handleVoucherSelect(res?.data[0])
      }).catch((err) => {
        const error = err?.response?.data
        if (error.statusCode === 404) {
          if (error.message === "NOT_FOUND_VOUCHER_CODE") {
            setErrorSearchVoucher(t(`PAYMENT.MESSAGE.ERROR.${error.message}`))
          } else {
            notiError(t(`VOUCHER.POP_PRODUCT.MESSAGE.ERROR.${error.message}`))
          }
        } else {
          notiError(t(`VOUCHER.POP_PRODUCT.MESSAGE.ERROR.ERROR`))
        }
      })
    }
  }

  const handleAutoScrollBottom = () => {
    setTimeout(() => {
      const container = containerModalRef.current;
      if (container) {
        container.scrollTo({
          top: container.scrollHeight,
          behavior: "smooth",
        });
      }
    }, 100)
  }

  const renderOperativeTotal = useCallback(() => {
    return numberFormat((operative.total || 0))
  }, [operative.total, paymentInstallmentList])

  const renderVoucher = () => {
    if (voucherOperative?.voucherId) {
      return (
        <Box width={"100%"}>
          <Box display={'flex'} alignItems={'center'} flexWrap={'wrap'} marginBottom={'8px'}>
            <Box width={'140px'}>
              {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_NAME')}
            </Box>
            <Box display={'flex'} alignItems={'center'} gap={'8px'}>
              <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                {voucherOperative?.voucherName}
                {voucherOperative?.detail &&
                  (
                    <span>
                      <Tooltip title={voucherOperative?.detail} placement={'top-start'} sx={{ 'path': { fill: '#A8A8A8' }, }}>
                        <InfoIcon />
                      </Tooltip>
                    </span>
                  )
                }
              </Box>
            </Box>

          </Box>
          <Box display={'flex'} alignItems={'center'} flexWrap={'wrap'}>
            <Box width={'140px'}>
              {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_COST')}
            </Box>
            <Box display={'flex'} alignItems={'center'} gap={'8px'}>
              <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                {voucherOperative?.voucherPrice}
                {voucherOperative?.voucherPriceUnit === "PERCENT" ?
                  <Box>
                    {'%'}
                  </Box>
                  : <Box>
                    {t('PROMOTION.FORM.BATH')}
                  </Box>
                }
              </Box>
            </Box>

          </Box>
        </Box>
      )
    } else if (vouchers?.length && !isDisabledChange) {
      return (
        <Box width={"100%"}>
          {_.filter(vouchers, (voucher) => voucher.connectPatient === "0").map((item: any, index: number) => {
            return (
              <Box key={index} display={'flex'} alignItems={'center'} flexWrap={'wrap'}>
                <Box width={'140px'}>
                  {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_NAME')}
                </Box>
                <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                  <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                    {item?.voucherName}
                    {item?.detail &&
                      (
                        <span>
                          <Tooltip title={item?.detail} placement={'top-start'} sx={{ 'path': { fill: '#A8A8A8' }, }}>
                            <InfoIcon />
                          </Tooltip>
                        </span>
                      )
                    }
                  </Box>
                  <Box
                    sx={{ textDecoration: 'underline', color: colors.themeSecondColor, cursor: 'pointer', width: 'fit-content' }}
                    onClick={() => onOpenPopVoucherSelectLot(item)}
                  >
                    {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_SELECT_INDEX', { index: item?.voucherDetails?.length || 0 })}
                  </Box>
                </Box>

              </Box>
            )
          })}
        </Box>
      )
    } else {
      return (
        <Box width={"100%"}>
          <Box width={"100%"} alignContent={'center'} textAlign={'center'} color={'#808080'}>
            {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_NONE')}
          </Box>
        </Box>
      )
    }
  }



  const onSubmit = async (itemId: any) => {
    const newPayload: ApprovalCancelReceipt = {
      requestReason: treatments.summeryTreatments[itemId]?.approvalItems?.requestReason,
      requestUserName: treatments.summeryTreatments[itemId]?.approvalItems.requestUserName,
      requestUserId: treatments.summeryTreatments[itemId]?.approvalItems.requestUserId,
      approveRemark: treatments.summeryTreatments[itemId]?.approvalItems.approveRemark,
      refId: treatments.summeryTreatments[itemId]?.approvalItems.refId,
      branchId: getBranch(),
      status: ApprovalStatus.CANCEL
    }
    await ApprovalApi.approvalCancelReceipt(treatments.summeryTreatments[itemId]?.approvalItems.approvalItemId, newPayload).then((res) => {
      notiSuccess(t('APPROVAL.MESSAGE.SUC_CREATE'))
      dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: treatments.summeryTreatmentsOld }))
      // setOpenModal(false)
      // setIsDisabledChange(false)
      // setApproval(false)

      window.location.reload();
      //setLoading(true)
    }).catch((e) => {
      const error = e.response?.data?.message
      const errorMessage = ["IS_APPROVED", "IS_CANCEL"]
      if (errorMessage.includes(error)) {
        swalCustom(
          t(`APPROVELLIST.MESSAGE.${error}_TITLE`),
          t(`APPROVELLIST.MESSAGE.${error}_SUB`),
          () => {
            setOpenModal(false);
            window.location.reload();
          },
          'warning',
          { cancelButton: { showCancelButton: false }, showCloseButton: false }
        )
      } else {
        notiError(t('APPROVELLIST.MESSAGE.ERROR'))
      }
    }).finally(() => {
      setLoading(false)
    })
  }


  const renderBody = () => {
    return (
      <>
        <Box ref={containerModalRef} className="custom-scroll" sx={{ overflowY: 'auto' }}>
          <Grid container spacing={2}>
            <Grid container item xs={12} className={'w-100 align-items-center'}>
              <Grid item xs={!approval && !outToken ? 6 : 12} className={`text-nowrap d-flex align-items-center`}>
                <Typography className="d-sm-inline-block" sx={{ fontWeight: 500 }}>
                  {t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.OPERATIVE_ID')}: {operative.operativeCode || '-'}
                </Typography>
                <Typography className="d-sm-inline-block pl-sm-3 text-ellipsis" sx={{ fontWeight: 500 }}>
                  {t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.OPERATIVE_NAME')}: {operative.operativeName || operative.operativeNameEn || '-'}
                </Typography>
              </Grid>

              {(!approval && approvalRight?.hasChangeCost && (props.itemId || props.itemId === 0) && Object.values(ApprovalStatus).includes(treatments.summeryTreatments[props.itemId]?.approvalItems?.status) && (treatments.summeryTreatments[props.itemId]?.approvalItems?.status !== ApprovalStatus.CANCEL)) ?
                <Grid item xs={6}>
                  <Box className={`d-flex justify-content-end align-items-center`}>
                    <ApprovalSelectorCustom
                      approval={treatments.summeryTreatments[props.itemId]?.approvalItems?.status as ApprovalStatus}
                      disabled
                      userApprovel={{
                        fullname: treatments.summeryTreatments[props.itemId]?.approvalItems?.approvedBy,
                        date: treatments.summeryTreatments[props.itemId]?.approvalItems?.approvedAt
                      }}
                      onClick={setOpenModal}
                    />
                  </Box>
                </Grid>
                : <></>
              }
            </Grid>
            <Grid item xs={6} className={'w-100'}>
              <InputTextField
                name="price"
                onchange={handleChange}
                onkeypress={handleChange}
                onkeyup={handleChange}
                value={operative.price}
                onfocus={() => setIsFocus('price')}
                onblur={() => handleBlurInput()}
                label={`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.PRICE_OF_UNIT')} (${t('CURRENCY_CHANGE.TH')})`}
                inputTextAlign="left"
                hideControl
                helperText={errorMessage.PRICE || ''}
                disabled={props?.noModal || isDisabledChange || operative.isEdit === '0'}
              />
            </Grid>
            <Grid item xs={6} className={'w-100'}>
              <InputTextField disabled={props?.noModal || isDisabledChange || operative.isEdit === '0'} name="qty"
                onchange={handleChange}
                // onkeypress={handleChange}
                // onkeyup={handleChange}
                value={operative.qty} label={`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.QUANTITY_OF_UNIT')}`} inputTextAlign="left" hideControl helperText={errorMessage.QTY || ''} />
            </Grid>
            <Grid item xs={12} className={'w-100'}>
              <InputTextField disabled name="treatment" value={numberFormat(normalPrice || 0)} label={`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.PRICE_OF_TREATMENT')} (${t('CURRENCY_CHANGE.TH')})`} inputTextAlign="left" hideControl />
            </Grid>


            <Grid item xs={12} className={'w-100'}>
              <Typography className="mt-2" sx={{ fontWeight: 500 }}>
                {t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.DISCOUNT_ADDON')}
              </Typography>
            </Grid>
            <Grid item xs={6} className={'w-100'}>
              <Grid container spacing={2}>
                <Grid item xs={6} sx={{ width: '50%' }}>
                  <InputTextField disabled={props?.noModal || isDisabledChange || operative.isEdit === '0'} name="discount"
                    onchange={handleChange}
                    onkeypress={handleChange}
                    onkeyup={handleChange}
                    value={operative.discount} label={`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.DISCOUNT')}`} inputTextAlign="left" hideControl />
                </Grid>
                <Grid item xs={6} sx={{ width: '50%' }}>
                  <BasicSelect
                    name="discountUnit"
                    labelId="lb-unit"
                    selectId="sl-unit"
                    label=""
                    value={operative.discountUnit || ''}
                    options={_.map(units, (unit: string, index: number) => {
                      return (
                        <MenuItem key={index} value={unit}>
                          {unit === CURRENCY_UNIT.PERCENT ? '%' : t('CURRENCY_CHANGE.TH')}
                        </MenuItem>
                      )
                    })}
                    onchange={handleChange}
                    disabled={props?.noModal || isDisabledChange || operative.isEdit === '0'}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={6} className={'w-100'}>
              <Grid container spacing={2}>
                <Grid item xs={6} sx={{ width: '50%' }}>
                  <InputTextField disabled={props?.noModal || isDisabledChange || operative.isEdit === '0'} name="additional"
                    onchange={handleChange}
                    onkeypress={handleChange}
                    onkeyup={handleChange}
                    value={operative.additional} label={`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.ADDON')}`} inputTextAlign="left" hideControl />
                </Grid>
                <Grid item xs={6} sx={{ width: '50%' }}>
                  <BasicSelect
                    name="additionalUnit"
                    labelId="lb-unit"
                    selectId="sl-unit"
                    label=""
                    value={operative.additionalUnit || ''}
                    options={_.map(units, (unit: string, index: number) => {
                      return (
                        <MenuItem key={index} value={unit}>
                          {unit === CURRENCY_UNIT.PERCENT ? '%' : t('CURRENCY_CHANGE.TH')}
                        </MenuItem>
                      )
                    })}
                    onchange={handleChange}
                    disabled={props?.noModal || isDisabledChange || operative.isEdit === '0'}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12} className={'w-100 mb-2'}>
              <Box display="flex" flexDirection="row" alignItems="center" gap="4px">
                <Typography marginLeft="16px">•</Typography>
                <Typography sx={{ fontWeight: 500 }}>
                  {t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.SALARY')}
                </Typography>
                <Typography>
                  {t('(ส่วนนี้ไม่สามารถใช้ส่วนลดร่วมกับแบ่งชำระได้)')}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6} className={'w-100 pt-2 pr-sm-2 pr-xl-3'} sx={{ borderRight: { xs: `1px solid ${colors.lightGray}` } }}>
              <Grid container spacing={2}>
                <Grid item xs={12} className="w-100">
                  <InputTextField
                    disabled
                    name="df"
                    value={numberFormat(df || 0)}
                    label={`${t(`DF ${operative.dfAmount} ${operative.dfUnit === 'PERCENT' ? `%` : `${t('CURRENCY_CHANGE.TH')}`}`)}`}
                    inputTextAlign="left"
                    hideControl

                  />
                </Grid>
                <Grid item lg={4} sx={{ width: '50%' }}>
                  <InputTextField disabled={props?.noModal || isDisabledChange || paymentInstallment === "1"} name="dfDiscountAmount"
                    onchange={handleChange}
                    onkeypress={handleChange}
                    onkeyup={handleChange}
                    value={operative.dfDiscountAmount} label={`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.DISCOUNT')}`} inputTextAlign="left" hideControl />
                </Grid>
                <Grid item lg={4} sx={{ width: '50%' }}>
                  <BasicSelect
                    name="dfDiscountUnit"
                    labelId="lb-unit"
                    selectId="sl-unit"
                    label=""
                    value={operative.dfDiscountUnit || ''}
                    options={_.map(units, (unit: string, index: number) => {
                      return (
                        <MenuItem key={index} value={unit}>
                          {unit === CURRENCY_UNIT.PERCENT ? '%' : t('CURRENCY_CHANGE.TH')}
                        </MenuItem>
                      )
                    })}
                    onchange={handleChange}
                    disabled={props?.noModal || isDisabledChange || paymentInstallment === "1" || operative.isEdit === '0'}
                  />
                </Grid>
                <Grid item lg={4} className="w-100">
                  <InputTextField disabled name="df-discount" value={numberFormat(dfDiscountAmount || 0)} label={`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.DISCOUNT')} (${t('CURRENCY_CHANGE.TH')})`} inputTextAlign="left" hideControl />
                </Grid>
                <Grid item xs={12} className="w-100">
                  <InputTextField disabled name="df-balance" value={numberFormat(df - dfDiscountAmount <= 0 ? 0 : df - dfDiscountAmount)} label={`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.BALANCE')}`} inputTextAlign="left" hideControl />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={6} className={'w-100 pt-2 pl-sm-2 pl-xl-3'}>
              <Grid container spacing={2}>
                <Grid item xs={12} className="w-100">
                  <InputTextField
                    disabled
                    name="cfAmount"
                    value={numberFormat(cf > 0 ? cf : 0)}
                    label={`${t(`CF ${operative.cfAmount} ${operative.dfUnit === 'PERCENT' ? `% ` : `${t('CURRENCY_CHANGE.TH')}`}`)}`}
                    inputTextAlign="left"
                    hideControl
                  />
                </Grid>
                <Grid item lg={4} sx={{ width: '50%' }}>
                  <InputTextField disabled={props?.noModal || isDisabledChange || paymentInstallment === "1"} name="cfDiscountAmount"
                    onchange={handleChange}
                    onkeypress={handleChange}
                    onkeyup={handleChange}
                    value={operative.cfDiscountAmount} label={`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.DISCOUNT')}`} inputTextAlign="left" hideControl />
                </Grid>
                <Grid item lg={4} sx={{ width: '50%' }}>
                  <BasicSelect
                    name="cfDiscountUnit"
                    labelId="lb-unit"
                    selectId="sl-unit"
                    label=""
                    value={operative.cfDiscountUnit || ''}
                    options={_.map(units, (unit: string, index: number) => {
                      return (
                        <MenuItem key={index} value={unit}>
                          {unit === CURRENCY_UNIT.PERCENT ? '%' : t('CURRENCY_CHANGE.TH')}
                        </MenuItem>
                      )
                    })}
                    onchange={handleChange}
                    disabled={props?.noModal || isDisabledChange || paymentInstallment === "1" || operative.isEdit === '0'}
                  />
                </Grid>
                <Grid item lg={4} className="w-100">
                  <InputTextField disabled name="cf-discount" value={numberFormat(cfDiscountAmount || 0)} label={`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.DISCOUNT')} (${t('CURRENCY_CHANGE.TH')})`} inputTextAlign="left" hideControl />
                </Grid>
                <Grid item xs={12} className="w-100">
                  <InputTextField disabled name="cf-balance" value={numberFormat(cf - cfDiscountAmount <= 0 ? 0 : cf - cfDiscountAmount)} label={`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.BALANCE')}`} inputTextAlign="left" hideControl />
                </Grid>
              </Grid>
            </Grid>

            {/* {(!approval && isPromtion && getCrm()) && */}
            {/* <Grid container item xs={12} > */}
            {branchInfo.isUseCrm === '1' && <Grid item xs={12} md={6} paddingRight={{ md: '16px', xs: '' }} borderRight={{ md: `1px solid ${colors.lightGray}`, xd: '' }}>
              <Box fontWeight={'500'}>
                {t('PROMOTION.MODAL_MANAGE.PROMOTION')}
              </Box>
              <Box display={'flex'} flexDirection={'column'} gap={'16px'} marginTop={'16px'}>
                <Box sx={{ '.MuiOutlinedInput-root': { paddingRight: '9px !important' }, '.MuiAutocomplete-popupIndicator': { transform: 'rotate(0deg) !important' } }}>
                  <AutocompleteSelect
                    labelId={'promotion'}
                    inputLabel={t('PROMOTION.FORM.PROMOTION_NAME')}
                    noOptionsText={t('NOT_FOUND')}
                    getOptionLabel={(option) => option?.promotionFullName || ''}
                    options={promotion?.list || []}
                    popupIcon={<FontAwesomeIcon icon={faSearch} style={{ fontSize: 15 }} />}
                    renderOption={(props, option) => {
                      return (
                        <Box {...props}
                          aria-disabled={promotion?.used.includes(option?.promotionBranchId)}
                        >
                          {option?.promotionName || ''}
                        </Box>
                      )
                    }}
                    onchange={(e, value) => handleChangePromotion(value)}
                    value={promotion?.current || ''}
                    disableClearable={!promotion?.current?.promotionBranchId}
                    disabled={props.noModal || isDisabledChange || operative.isEdit === '0'}
                  />
                </Box>
                {(promotion?.current?.promotionBranchId) ?
                  <Box width={"100%"}>
                    <Box padding={'0 24px'} display={'flex'} flexDirection={'column'} gap={'8px'}>
                      <Box display={'flex'} alignItems={'center'} width={'100%'}>
                        <Box minWidth={'160px'}>
                          {t('PROMOTION.FORM.PROMOTION_NAME')}
                        </Box>
                        <Box className={'text-ellipsis'} width={'100%'} >
                          {promotion?.current?.promotionName}
                          {promotion?.current?.detail &&
                            (
                              <span>
                                <Tooltip title={promotion?.current?.detail} placement={'top-start'} sx={{ 'path': { fill: '#A8A8A8' }, }}>
                                  <InfoIcon />
                                </Tooltip>
                              </span>
                            )
                          }
                        </Box>
                      </Box>
                      <Box display={'flex'} alignItems={'center'} width={'100%'}>
                        <Box minWidth={'160px'}>
                          {t('PROMOTION.FORM.TYPE')}
                        </Box>
                        <Box className={'text-ellipsis'} width={'100%'} >
                          {promotion?.current?.type === 'DISCOUNT' ? t('PROMOTION.PROMOTION_TYPE.DISCOUNT') : t('PROMOTION.PROMOTION_TYPE.EXTRA')}
                        </Box>
                      </Box>
                      {promotion?.current?.type === 'DISCOUNT' ?
                        <Box display={'flex'} alignItems={'center'} width={'100%'}>
                          <Box minWidth={'160px'}>
                            {t('PROMOTION.FORM.COST')}
                          </Box>
                          <Box className={'text-ellipsis'} width={'100%'} >
                            {promotion?.current?.promotionPrice} {promotion?.current?.promotionPriceUnit === "PERCENT" ? "%" : t('PROMOTION.FORM.BATH')}
                          </Box>
                        </Box>
                        :
                        <Box display={'flex'} alignItems={'center'} width={'100%'}>
                          <Box minWidth={'160px'}>
                            {t('PROMOTION.MODAL_MANAGE.LIST_EXTRA')}
                          </Box>
                          <Box className={'text-ellipsis'} width={'100%'} title={renderDetailListExtra(promotion?.extraCurrent)}>
                            {renderDetailListExtra(promotion?.extraCurrent)}
                          </Box>
                        </Box>
                      }
                    </Box>
                  </Box>
                  : <Box width={"100%"} alignContent={'center'} textAlign={'center'} color={'#808080'}>
                    {t('PROMOTION.MODAL_MANAGE.NONE_PROMOTION')}
                  </Box>
                }
                {/* {
                  promotions?.length && promotions.filter((item: any) => item?.promotionBranchId !== promotion?.current?.promotionBranchId)?.length ?
                    <Box margin={'8px 0'}>
                      <Box>
                        {t('PROMOTION.MODAL_MANAGE.PROMOTION_BIND')}
                      </Box>
                      <Box width={"100%"}>
                        {promotions.filter((item: any) => item?.promotionBranchId !== promotion?.current?.promotionBranchId).map((item: any, index: number) => {
                          if (item?.promotionBranchId !== promotion?.current?.promotionBranchId) {
                            return (
                              <Box key={index} padding={'0 24px'} display={'flex'} flexDirection={'column'} gap={'8px'}>
                                <Box display={'flex'} alignItems={'center'} width={'100%'}>
                                  <Box minWidth={'160px'}>
                                    {t('PROMOTION.FORM.PROMOTION_NAME')}
                                  </Box>
                                  <Box className={'text-ellipsis'} width={'100%'} >
                                    {item?.promotionName}
                                    {item?.detail &&
                                      (
                                        <span>
                                          <Tooltip title={item?.detail} placement={'top-start'} sx={{ 'path': { fill: '#A8A8A8' }, }}>
                                            <InfoIcon />
                                          </Tooltip>
                                        </span>
                                      )
                                    }
                                  </Box>
                                </Box>
                                <Box display={'flex'} alignItems={'center'} width={'100%'}>
                                  <Box minWidth={'160px'}>
                                    {t('PROMOTION.FORM.TYPE')}
                                  </Box>
                                  <Box className={'text-ellipsis'} width={'100%'} >
                                    {item?.type === 'DISCOUNT' ? t('PROMOTION.PROMOTION_TYPE.DISCOUNT') : t('PROMOTION.PROMOTION_TYPE.EXTRA')}
                                  </Box>
                                </Box>
                                {item?.type === 'DISCOUNT' ?
                                  <Box display={'flex'} alignItems={'center'} width={'100%'}>
                                    <Box minWidth={'160px'}>
                                      {t('PROMOTION.FORM.COST')}
                                    </Box>
                                    <Box className={'text-ellipsis'} width={'100%'} >
                                      {item?.promotionPrice} {item?.promotionPriceUnit === "PERCENT" ? "%" : t('PROMOTION.FORM.BATH')}
                                    </Box>
                                  </Box>
                                  :
                                  <Box display={'flex'} alignItems={'center'} width={'100%'}>
                                    <Box minWidth={'160px'}>
                                      {t('PROMOTION.MODAL_MANAGE.LIST_EXTRA')}
                                    </Box>
                                    <Box className={'text-ellipsis'} width={'100%'} title={renderDetailListExtra([], index)}>
                                      {renderDetailListExtra([], index)}
                                    </Box>
                                  </Box>
                                }
                              </Box>
                            )
                          }
                        })}
                      </Box>

                    </Box>

                    : <></>} */}
              </Box>
            </Grid>}
            {branchInfo.isUseCrm === '1' && <Grid item xs={12} md={6} paddingLeft={{ md: '16px', xs: '' }}>
              <Box fontWeight={'500'}>
                Gift Voucher
              </Box>
              <Box display={'flex'} flexDirection={'column'} gap={'16px'} marginTop={'16px'}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <Box sx={{ width: '100%', '.MuiOutlinedInput-root': { paddingRight: '9px !important' }, '.MuiFormControl-root': { position: 'relative' }, '.MuiFormHelperText-root': { position: 'absolute', bottom: '-20px' } }}>
                    <InputTextField
                      label={t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_CODE')}
                      onchange={(event) => {
                        setErrorSearchVoucher("")
                        setSearchVoucher(event.target.value)
                      }}
                      value={searchVoucher}
                      // onblur={() => setSearchVoucher(voucherOperative?.voucherCode || '')}
                      inputProps={{
                        endAdornment: (
                          <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                            {voucherOperative?.voucherName &&
                              <Box sx={{ cursor: 'pointer' }} onClick={handleVoucherSelect}>
                                <IconClose />
                              </Box>
                            }
                            <FontAwesomeIcon icon={faSearch} style={{ fontSize: 15 }} />
                          </Box>
                        ),
                      }}
                      helperText={errorSearchVoucher}
                      disabled={props.noModal || isDisabledChange || operative.isEdit === '0'}
                    />
                  </Box>
                  <Box sx={{ minWidth: '100px', button: { width: '100%' } }}>
                    <MainButton
                      onClick={onLoadVoucher}
                      title={t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_CHECKCODE')}
                      type={'primary'}
                      variant={'outlined'}
                      disabled={props.noModal || isDisabledChange || operative.isEdit === '0'}
                    />
                  </Box>
                </Box>
                <Box padding={'16px 16px 0 16px'}>
                  {renderVoucher()}
                </Box>

              </Box>
            </Grid>}
            {/* } */}


            <Grid item xs={12} className={'w-100'}>
              <InputTextField disabled name="total" value={numberFormat(amount || 0)} label={`${t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.TOTAL')}`} inputTextAlign="left" hideControl />
            </Grid>

            <Grid item xs={12} className={'w-100'}>
              <Typography className="mt-2" sx={{ fontWeight: 500 }}>
                {t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.CLINIC_FEE')}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <BasicSelect
                name="clinicFeeId"
                labelId="lb-clinic-fee"
                selectId="sl-clinic-fee"
                label={t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.CLINIC_FEE')}
                value={operative.clinicFeeId || ''}
                options={_.map(clinicFees, (clinic: ClinicFeeType, index: number) => {
                  return (
                    <MenuItem key={index} value={clinic.clinicFeeId}>
                      {clinic.clinicFeeText} ({clinic.price} {t('CURRENCY_CHANGE.TH')})
                    </MenuItem>
                  )
                })}
                onchange={(e: any) =>
                  setOperative({
                    ...operative,
                    clinicFeeId: e.target.value,
                    clinicFeeName: _.get(_.find(clinicFees, { clinicFeeId: e.target.value }), 'clinicFeeText'),
                    clinicFeePrice: _.get(_.find(clinicFees, { clinicFeeId: e.target.value }), 'price')
                  })
                }
                allowClear
                onClear={() => setOperative(_.omit(operative, ['clinicFeeId', 'clinicFeeName', 'clinicFeeNameEn']))}
                disabled={props?.noModal || isDisabledChange || operative.isEdit === '0'}
              />
            </Grid>
            {!props?.noModal &&
              <Grid item xs={12} className="w-100">
                <InputTextarea disabled={
                  Config.IS_TDH === '1' && hasSignature && props.type === 'Payment' ? !hasSignature : isDisabledChange || operative.isEdit === '0'} name="dfRemark" label={t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.REMARK')} value={operative.dfRemark} onchange={handleChange} height={94} />
              </Grid>
            }

            <Grid item xs={12}  >
              <Box>
                <Typography className="mt-2" sx={{ fontWeight: 500 }}>
                  {t('TREATMENT_COURSE.FORM.PAYMENT.PAYMENT_METHOD_TITLE')}
                </Typography>
              </Box>
              <Box margin={'16px 0'}>
                <SelectInput
                  label={t('TREATMENT_COURSE.FORM.PAYMENT.PAYMENT_METHOD_TITLE')}
                  onChange={(e) => {
                    setIsPaymentInstallmentLoad(true)
                    setPaymentInstallment(e.target.value)
                    handleAutoScrollBottom()
                  }}
                  options={paymentInstallmentOption}
                  value={paymentInstallment.toString()}
                  disabled={props?.noModal || isDisabledChange || operative.isEdit === '0'}
                />
              </Box>
              {paymentInstallment === "1" &&
                <Box>
                  <Box marginBottom={'16px'}>
                    <TextInput
                      fullWidth
                      label={t('TREATMENT_COURSE.FORM.PAYMENT.PAYMENT_METHOD_TOTAL')}
                      disabled
                      onChange={() => null}
                      value={numberFormat(operativeTotal)}
                    />
                  </Box>
                  <Box padding={{ md: "0 24px", sm: '0px' }}>
                    <PaymentInstallmentBox
                      operativeTotal={operativeTotal}
                      paymentInstallmentList={paymentInstallmentList}
                      setPaymentInstallmentList={(prev: any) => {
                        setIsPaymentInstallmentLoad(true)
                        setPaymentInstallmentList(prev)
                      }}
                      autoScroll={handleAutoScrollBottom}
                      disabled={operative.isEdit === '0' || window.location.pathname === '/approvel-list/change-cost'}
                    />

                  </Box>
                </Box>
              }
            </Grid>
          </Grid>
        </Box >

        <Box className="py-3">
          <Grid container spacing={1}>
            <Grid item xs={4} sm={5} className="pt-0 d-none d-sm-block"></Grid>
            <Grid item xs={4} sm={4} className="pt-0" sx={{ width: '50%' }}>
              <Title className="d-inline-block">
                {t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.TOTAL_DISCOUNT')} ({t('CURRENCY_CHANGE.TH')}):
              </Title>
            </Grid>
            <Grid item xs={4} sm={3} className="pt-0 text-right" sx={{ width: '50%' }}>
              <Title className="d-inline-block">{numberFormat(discountAmount + dfDiscountAmount + (cfDiscountAmount || 0) + (operative?.dfPromotionDiscountAmount || 0) + (operative?.cfPromotionDiscountAmount || 0) + (operative?.dfVoucherDiscountAmount || 0) + (operative?.cfVoucherDiscountAmount || 0))}</Title>
            </Grid>
            <Grid item xs={4} sm={5} className="pt-0 d-none d-sm-block"></Grid>
            <Grid item xs={4} sm={4} className="pt-0" sx={{ width: '50%' }}>
              <Title className="d-inline-block">
                {t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.TOTAL_NET')} ({t('CURRENCY_CHANGE.TH')}):
              </Title>
            </Grid>
            <Grid item xs={4} sm={3} className="pt-0 text-right" sx={{ width: '50%' }}>
              <Title className="d-inline-block">{renderOperativeTotal()}</Title>
            </Grid>
          </Grid>
        </Box>

        {
          operative?.doctorName &&
          <Box marginTop={'8px'}>
            <Box component={'span'} fontWeight={'500'}>
              {t('MODAL_TREATMENT_CONSENT.SIGN_TABS.DOCTOR')}:
            </Box>
            <Box component={'span'}>
              {`  ${operative?.doctorName}`}
            </Box>
          </Box>
        }

        {
          popPromotionExtra &&
          <ModalSelectPromotionExtra
            promotionExtraValue={promotion?.extraCurrent}
            onClose={onClerPopPromotionExtra}
            promotionExtra={promotion?.extraList}
            onChangePromotionExtra={onChangePromotionExtra}
            promotionBuy={promotion?.package}
          />
        }

        {
          popVoucherSelectLot &&
          <ModalVoucherSelectLot
            onClose={onClerPopVoucherSelectLot}
            data={dataPopVoucherSelectLot}
            handleVoucherSelect={handleVoucherSelect}
          />
        }


        <Box>
          <AlertModal
            isOpen={openModal}
            handleClose={() => setOpenModal(false)}
            type={'error'}
            title={`${t('APPROVAL.ALERT.CANCEL')}`}
            message={`${t('APPROVAL.ALERT.CHANEL_APPROVAL')}`}
            onSubmit={{ onClick: () => onSubmit(props.itemId), title: t('BUTTON.SUBMIT') }}
            onCancel={{ onClick: () => setOpenModal(false) }}
          />
        </Box>

      </>
    )
  }

  const renderModal = () => {
    return (
      <ModalCustom
        size={'xl'}
        title={t('TREATMENT_SUMMARY.POPUP.TREATMENT_COURSE.TITLE')}
        alignFooter={'end'}
        fullscreen={'xxl-down'}
        footerInline
        disabledSubmit={disabledSave}
        textBtnCancel={t('BUTTON.CANCEL')}
        textBtnConfirm={t('BUTTON.SAVE')}
        onReset={props.onReset}
        onSubmit={() => handleSubmit()}
        modalStyle={`modal-treatment-course ${disabled ? 'disabled-modal-footer' : ''}`}
        component={renderBody()}
      />
    )
  }

  if (!props?.noModal) {
    return (
      (!loading && (
        renderModal()
      ) || (
          <CustomLoading className="d-flex align-items-center justify-content-center">
            <Loading show={true} type="fullLoading" />
          </CustomLoading>
        )
      )
    )
  } else {
    return renderBody()
  }
}

type ModalVoucherSelectLotProps = {
  onClose: () => void
  data: any
  handleVoucherSelect: (item: any) => void
}

export const ModalVoucherSelectLot = (props: ModalVoucherSelectLotProps) => {
  const { t } = useTranslation()

  const [page, setPage] = useState<number>(1)
  const [pageLimit, setPageLimit] = useState<number>(5)
  const [rowCount, setRowCount] = useState<number>(0)
  const [sortBy, setSortBy] = useState('voucherId')
  const [sortType, setSortType] = useState('DESC')

  const [copy, setCopy] = useState(0)

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => setPage(val)

  const handleChangeRowsPerPage = (limit: number) => setPageLimit(limit)

  const headCells = [
    { id: 'no', disablePadding: false, label: t('#'), width: '50px', align: 'center', },
    { id: 'code', disablePadding: false, label: t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_CODE_'), align: 'left', width: '50%', class: 'text-nowrap ' },
    { id: 'codeList', disablePadding: false, label: t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_CODE_LOT'), width: '100px', align: 'center', class: 'text-nowrap ' },
    { id: 'endDate', disablePadding: false, label: t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_DATEEND'), width: '120px', align: 'center', class: 'text-nowrap ' },
    { id: 'action', disablePadding: false, label: t('Action'), width: '100px', align: 'center', class: 'text-nowrap ' },
  ]

  const renderData = (objData: any, index: number,) => {
    index = page * pageLimit - pageLimit + index + 1
    const { voucherListId, voucherCode, endDate, lotNumber } = objData

    const commonColumns = [
      { option: 'TEXT', align: 'center', label: index },
      {
        option: 'COMPONENT', class: 'text-nowrap', component: (
          <Box display={'flex'} alignItems={'center'} gap={'8px'} >
            {voucherCode}
            <Box onClick={() => handleCopyClick(voucherCode, index)} sx={{ cursor: 'pointer', 'svg': { fill: '#808080' } }}>
              <FileCopyOutlinedIcon />
              <Box>
                {copy === index &&
                  <Box position="absolute" padding="10px" bgcolor="#5A5A5A" color="#FFFFFF" borderRadius="2px" top="-40px" fontSize="14px" fontWeight={400}>Copied</Box>
                }
              </Box>
            </Box>
          </Box>
        )
      },
      { option: 'TEXT', class: 'text-nowrap ', align: 'center', label: lotNumber },
      { option: 'TEXT', align: 'center', label: dateToView(endDate) },
      {
        option: 'COMPONENT', class: 'text-nowrap', component: (
          <Box textAlign={'center'} sx={{ button: { minWidth: 'fit-content !important', padding: '0 14px', fontSize: '20px', fontWeight: '600' } }}>
            <MainButton
              type={'primary'}
              variant={'contained'}
              title={'+'}
              onClick={() => props.handleVoucherSelect(objData)}
            />
          </Box>
        )
      },
    ]

    const objRenderData = {
      key: voucherListId,
      id: voucherListId,
      obj: objData,
      columns: commonColumns
    }

    return <TableRowCommon {...objRenderData} />
  }

  const renderVoucher = () => {
    const startIndex = (page - 1) * pageLimit
    return props.data?.voucherDetails?.slice(startIndex, startIndex + pageLimit)
  }

  useEffect(() => {
    setRowCount(props.data?.voucherDetails?.length || 0)
  }, [props.data?.voucherDetails])

  const handleCopyClick = (text: string, index: number) => {
    setCopy(index);
    navigator?.clipboard?.writeText(text)
    setTimeout(() => {
      setCopy(0);
    }, 2000);
  };

  return (
    <Box
      position={'fixed'}
      zIndex={2900}
      top={0}
      right={0}
      left={0}
      bottom={0}
      width={'100%'}
      height={'100%'}
    >
      <Box display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'} height={'100%'} padding={'24px'} bgcolor={'#231f201a'} >
        <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} height={'fit-content'} gap={'24px'} bgcolor={'#fff'} padding={'24px'} borderRadius={'10px'} overflow={'hidden'} position={'relative'} maxWidth={'800px'} width={'100%'}>
          <Box position={'absolute'} top={'12px'} right={'12px'} sx={{ cursor: 'pointer', path: { fill: '#000000 !important', stroke: 'transparent !important', opacity: '0.5' } }}
            onClick={props.onClose}
          >
            <IconClose />
          </Box>
          <Box textAlign={'center'} fontSize={'20px'} fontWeight={'600'} color={colors.themeMainColor} >
            {t('VOUCHER.POP_PRODUCT.FORM.VOUCHER_CODE')}
          </Box>
          <Box display={'flex'} flexDirection={'column'} height={'100%'} overflow={'hidden'}>
            <Box display={'flex'} alignItems={'center'} gap={'8px'} >
              <Box>
                {t('VOUCHER.POP_PRODUCT.FORM.NAME')}
              </Box>
              <Box>
                {props.data?.voucherName}
              </Box>

              {props.data?.detail &&
                <span>
                  <Tooltip title={props.data?.detail} placement={'top-start'} sx={{ 'path': { fill: '#A8A8A8' }, }}>
                    <InfoIcon />
                  </Tooltip>
                </span>
              }
            </Box>
            <Box sx={{ marginTop: '16px', display: 'flex', flexDirection: 'column', height: 'calc(100% - 42px)' }}>
              <TableCustom
                page={page}
                pageLimit={pageLimit}
                sortType={sortType}
                sortBy={sortBy}
                onSort={onRequestSort}
                setPageLimit={handleChangeRowsPerPage}
                setPage={handleChangePage}
                rowCount={rowCount}
                headCells={headCells}
                rowsData={props.data?.voucherDetails?.length ? renderVoucher()?.map((item: any, index: number) => {
                  return renderData(item, index)
                }) : []}
              />
            </Box>
          </Box>
          <Box width={'100%'} display={'flex'} justifyContent={'flex-end'}>
            <MainButton
              onClick={props.onClose}
              type={'secondary'}
              title={t('BUTTON.CANCEL')}
              variant={'outlined'}
            />
          </Box>
        </Box>
      </Box>


    </Box>
  )
}

